<div class="container-fluid">
  <app-pagetitle title="Remix Icons" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="row">
    <div class="col-12" id="icons"></div>
    <!-- end col-->
  </div>
  <!-- end row-->
</div>
